import { type ReactNode } from 'react'
import { useScrollOffsets } from '@/hooks/element-hooks'
import {
  StickyViewHeader,
  StickyViewHeaderMain,
} from '@/components/StickyViewHeader'
import { Sandwich, SandwichBun, SandwichContent } from '@/components/Sandwich'
import { ViewHeading } from '@/components/ViewHeading'
import { ContentLayout, ContentMain } from '@/components/ContentLayout'
import { ListHeader } from '@/components/ListHeader'
import { SidebarTip } from '@/features/payouts/pro/components/SidebarTip'

export interface ProPayoutsViewProps {
  transactionsCount: number
  summary: ReactNode
  transactionsTable: ReactNode
}

export function ProPayoutsView({
  transactionsCount,
  summary,
  transactionsTable,
}: ProPayoutsViewProps) {
  const { connectRef: scrollRef, scrollYStart: scrollOffset } =
    useScrollOffsets()

  return (
    <Sandwich stretch>
      <SandwichBun>
        <StickyViewHeader scrollOffset={scrollOffset}>
          <StickyViewHeaderMain>
            <ViewHeading primaryText="Payouts" secondaryText="Earnings" />
          </StickyViewHeaderMain>
        </StickyViewHeader>
      </SandwichBun>
      <SandwichContent stretch>
        <ContentLayout accountForLabel fill ref={scrollRef}>
          <ContentMain fill constrainWidth>
            <Sandwich stretch>
              <SandwichBun>
                <ListHeader>Analytics</ListHeader>
                {summary}
                <ListHeader count={transactionsCount || undefined}>
                  Transaction history
                </ListHeader>
              </SandwichBun>
              <SandwichContent stretch>{transactionsTable}</SandwichContent>
            </Sandwich>
          </ContentMain>
          <SidebarTip />
        </ContentLayout>
      </SandwichContent>
    </Sandwich>
  )
}
